import { brandAssets } from './brandAssets';

type BrandMarkProps = {
  className?: string;
};

/** Monitor mark — SVG only. */
export function BrandMark({ className = 'h-12 w-12' }: BrandMarkProps) {
  return (
    <img
      src={brandAssets.monitorIcon}
      alt=""
      aria-hidden
      draggable={false}
      className={`${className} select-none object-contain`.trim()}
    />
  );
}
